import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import errorImage from '../../../../../images/Error.svg';
import WhiteboxPage from '../../../../../components/WhiteboxPage';
import { usePageViewedEvent } from '../../../../../utilities/analytics/analytics-web-client';

const MessageContainer = styled.div`
  margin-bottom: 24px;
`;

export const pageId = 'welcomeRateLimitExceededErrorPage';

export const WelcomeRateLimitExceededError = () => {
  usePageViewedEvent(pageId);

  return (
    <WhiteboxPage
      pageId={pageId}
      header={
        <>
          <MessageContainer>
            <FormattedMessage
              id="welcome.rate-limit-exceeded.error.title"
              defaultMessage="We couldn't verify your email"
              description="Telling the user that there is an error and they're not verified. The error is caused by too many attempts submitting the link."
              tagName="h5"
            />
          </MessageContainer>
          <img src={errorImage} width="99" alt="" />
        </>
      }>
      <FormattedMessage
        id="welcome.rate-limit-exceeded.error.main-action"
        defaultMessage="There have been too many attempts to verify your account in the past hour. Please try again after an hour."
        description="Telling the user that there has been too many attempts on the welcome link and to try again later by refreshing or clicking the link again."
      />
    </WhiteboxPage>
  );
};

export default WelcomeRateLimitExceededError;
